import React, { FC } from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';

import UniversalImage from 'components/common/UniversalImage';
import IconCustom from 'components/common/IconCustom';
import DangerouslySetInnerHtml from 'components/common/DangerouslySetInnerHtml';

import { IIllustration } from '../model';
import './SymptomIllustration.scss';

const SymptomIllustration: FC<IIllustration> = ({
  title,
  titleRTE,
  imageAlt,
  image,
  path,
  description,
  isTitleFirst,
  symptomsTheme,
}) => {
  const classes = classNames('nf-symptom-illustration', {
    'has-description': description,
    'text-center': isTitleFirst,
    [`nf-symptom-illustration--${symptomsTheme}`]: symptomsTheme,
  });

  const symptomContent = (
    <div className={classes} data-test="SymptomIllustration">
      <div className="nf-symptom-illustration__illustration_holder">
        {!isTitleFirst && image ? (
          <UniversalImage
            imageAlt={imageAlt}
            img={image}
            imageStyle={{ width: '73px', height: '73px' }}
          />
        ) : null}
        {description ? (
          <DangerouslySetInnerHtml
            className="nf-symptom-illustration__item-text"
            html={description}
          />
        ) : null}
        {titleRTE ? (
          <DangerouslySetInnerHtml
            html={titleRTE}
            className="nf-symptom-illustration__title title-rte"
          />
        ) : title ? (
          <DangerouslySetInnerHtml html={title} className="nf-symptom-illustration__title" />
        ) : null}
        {isTitleFirst && image ? (
          <UniversalImage
            imageAlt={imageAlt}
            img={image}
            imageStyle={{ width: '73px', height: '73px' }}
          />
        ) : null}
        {!isTitleFirst && path ? <IconCustom icon="arrow_forward_ios" /> : null}
      </div>
    </div>
  );

  return path ? (
    <Link to={path} className="nf-symptom-illustration__holder-link">
      {symptomContent}
    </Link>
  ) : (
    symptomContent
  );
};
export default SymptomIllustration;
